import { useQuery } from '@apollo/client/react';
import { PreBookingDetails } from '@drycut/booking-components';
import { type CompletePreBookingFragment, GetPreBookingDocument } from '@drycut/graphql';
import { Loader } from '@drycut/ui-components';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useDocumentTitle } from 'usehooks-ts';

import { useGtagEvent } from '../hooks';

export function PreBookingDetailsByUid(): React.ReactElement {
  useDocumentTitle('DRYCUT - Booking details');

  const { uid } = useParams() as { uid: string };
  const { data, loading } = useQuery(GetPreBookingDocument, { variables: { uid } });
  const { sendEvent } = useGtagEvent();

  // Send conversion event to Google
  useEffect(() => {
    sendEvent('conversion', {
      send_to: 'AW-866373683/nrFyCJqU6cQaELOgj50D',
    });
  }, [sendEvent]);

  if (loading) {
    return <Loader />;
  }

  const preBooking = data?.preBooking as CompletePreBookingFragment;

  return <PreBookingDetails preBooking={preBooking} />;
}
